import React, { useState, useRef, useEffect } from 'react';
import './SearchDropdown.css';

const SearchDropdown = ({ onSearch, onFilter, position }) => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filters, setFilters] = useState({
    sativa: false,
    hybrid: false,
    indica: false,
  });
  const [isOpen, setIsOpen] = useState(false);
  const [dropdownPosition, setDropdownPosition] = useState(position || 'center');
  const dropdownRef = useRef(null);

  useEffect(() => {
    // Close dropdown when clicking outside
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const handleButtonToggle = (classification) => {
    const updatedFilters = {
      ...filters,
      [classification]: !filters[classification],
    };
    setFilters(updatedFilters);
    onFilter(updatedFilters);
  };

  const handleSearchChange = (e) => {
    setSearchTerm(e.target.value);
    onSearch(e.target.value);
  };

  const toggleDropdown = (e) => {
    e.preventDefault();
    setIsOpen(!isOpen);
  };

  // Determine position when dropdown opens
  useEffect(() => {
    if (isOpen && dropdownRef.current) {
      const rect = dropdownRef.current.getBoundingClientRect();
      const windowWidth = window.innerWidth;
      
      // If near right edge of screen
      if (rect.right > windowWidth - 100) {
        setDropdownPosition('right');
      } 
      // If near left edge of screen
      else if (rect.left < 100) {
        setDropdownPosition('left');
      }
      // Default center
      else {
        setDropdownPosition('center');
      }
    }
  }, [isOpen]);

  return (
    <div className="sd-container" data-position={dropdownPosition} ref={dropdownRef}>
      <button
        onClick={toggleDropdown}
        className="sd-toggle-button"
      >
        <i className="bi bi-search"></i>
      </button>
      
      {isOpen && (
        <div className="sd-dropdown-menu">
          {/* Search Input */}
          <div className="sd-form-group">
            <input
              type="text"
              className="sd-input"
              placeholder="Search by brand or product name"
              value={searchTerm}
              onChange={handleSearchChange}
            />
          </div>

          {/* Classification Filter Buttons */}
          <div className="sd-button-group">
            <button
              className={`sd-filter-button ${filters.sativa ? 'sd-active' : ''}`}
              onClick={() => handleButtonToggle('sativa')}
            >
              Sativa
            </button>
            <button
              className={`sd-filter-button ${filters.hybrid ? 'sd-active' : ''}`}
              onClick={() => handleButtonToggle('hybrid')}
            >
              Hybrid
            </button>
            <button
              className={`sd-filter-button ${filters.indica ? 'sd-active' : ''}`}
              onClick={() => handleButtonToggle('indica')}
            >
              Indica
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

export default SearchDropdown;